import axios from 'axios'
import { apiGlobal } from './index'
import { LOCAL_STORAGE } from '@utils/Const'
const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const endPoints = {
  INIT: 'iesv/api/v1/users/init',
  SIGN_UP: 'iesv/api/v1/auth/signup',
  LOGIN: 'iesv/api/v1/auth/login',
  RESET_PASSWORD: 'iesv/api/v1/auth/reset-passwords',
  REFRESH_TOKEN: 'iesv/api/v1/auth/refresh-token',
  VERIFY_PHONE: 'iesv/api/v1/auth/verifications/phones',
  VERIFY_OTP: 'iesv/api/v1/auth/verifications/otp',
  RE_SEND_OTP: 'iesv/api/v1/auth/resend-otp',
  TEST: '/api/users',
  GET_USER_DETAILS: 'iesv/api/v1/users/details',
  INIT_CONVERSATION: 'iesv/api/v1/ielts/sessions',
  INIT_CONVERSATION_OPEN: 'iesv/api/v1/open/ielts/sessions',
  LIST_LESSON: 'iesv/api/v1/ielts/lessons',
  SEND_USER_AUDIO: 'iesv/api/v1/ielts/conversations/audio-messages',
  SEND_USER_AUDIO_OPEN: 'iesv/api/v1/open/ielts/conversations/audio-messages',
  GET_RESPONSE_CONVERSATION: 'iesv/api/v1/ielts/conversations/text-messages',
  GET_RESPONSE_CONVERSATION_OPEN:
    'iesv/api/v1/open/ielts/conversations/text-messages',
  GET_PROGRESS_BAR: 'iesv/api/v1/ielts/lessons/progress-bars',
  GET_PROGRESS_BAR_OPEN: 'iesv/api/v1/open/ielts/lessons/progress-bars',
  GET_SCORE: 'iesv/api/v1/ielts/conversations/user-score',
  GET_SCORE_OPEN: 'iesv/api/v1/open/ielts/conversations/user-score',
  GET_EXAM: 'iesv/api/v1/test',
  GET_EXAM_OPEN: 'iesv/api/v1/open/speak-tests',
  GET_DATA_TOPICS: 'iesv/api/v1/ielts/topics',
  GET_DATA_TOPICS_OPEN: 'iesv/api/v1/open/ielts/topics',
  GET_LESSONS: 'iesv/api/v1/ielts/lessons',
  GET_MORE_PRACTICE: 'iesv/api/v1/ielts/topic_by_type',
  GET_MORE_PRACTICE_OPEN: 'iesv/api/v1/open/ielts/topics',
  GET_MORE_TOPICS: 'iesv/api/v1/ielts/topic_by_type',
  GET_MORE_TOPICS_OPEN: 'iesv/api/v1/open/ielts/topics',
  GET_LESSON_DETAIL: 'iesv/api/v1/ielts/lessons/topics',
  GET_WORD_INFO: 'iesv/api/v1/add_on/word_info',
  GET_WORD_INFO_OPEN: 'iesv/api/v1/open/add_on/word_info',
  SUBMIT_PRE_ORDER: 'iesv/api/v1/products/pre-orders',
  SUBMIT_EXIT_FLOW_FEEDBACK: 'iesv/api/v1/feedbacks/exit-flow-feedbacks',
  SUBMIT_PROMOTE_FEEDBACK: 'iesv/api/v1/feedbacks/promote-feedbacks',
  SUBMIT_REAL_TIME_FEEDBACK: 'iesv/api/v1/feedbacks/real-time-feedbacks',
  SUBMIT_FEATURE_FEEDBACK: 'iesv/api/v1/feedbacks/feature-feedbacks',
  CHECK_IS_SHOW_PRE_ORDER: 'iesv/api/v1/products/pre-orders/status',
  SUBMIT_FEEDBACK_OPEN: 'iesv/api/v1/open/feedbacks',
  CHECK_DEVICE: 'iesv/api/v1/users/device-info',
  GET_PROFILE: 'iesv/api/v1/users/premium-status',
  GET_UPGRADE_PACKAGES: 'iesv/api/v1/products/packages',
  SUBMIT_UPGRADE: 'iesv/api/v1/products/premium-payments',
  GET_ORDER_DATA: 'iesv/api/v1/orders',
  TRACKING_PAGE: 'iesv/api/v1/users/tracking-screens',
  GET_TOPIC_OVERVIEW: 'iesv/api/v1/ielts/topics/overviews',
  GET_TOPIC_DETAIL: 'iesv/api/v1/ielts/topics/details',
  GET_FORECAST_SET:'iesv/api/v1/test/forecast-sets',
  SPEECH_CHECK: 'iesv/api/v1/check/speech',
}

const appRequest = {
  init: (params = {}) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.INIT, params, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
    }
    return apiGlobal.post(endPoints.INIT, params, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  login: async (params: any) => await apiGlobal.post(endPoints.LOGIN, params),
  register: async (params: any) =>
    await apiGlobal.post(endPoints.SIGN_UP, params),
  verifyPhone: async (params: any) =>
    await apiGlobal.post(endPoints.VERIFY_PHONE, params),
  verifyOTP: async (params: any) =>
    await apiGlobal.post(endPoints.VERIFY_OTP, params),
  resendOTP: async (params: any) =>
    await apiGlobal.post(endPoints.RE_SEND_OTP, params),
  resetPassword: async (params: any) =>
    await apiGlobal.put(endPoints.RESET_PASSWORD, params),
  getUserDetails: async () =>
    await apiGlobal.authGet(endPoints.GET_USER_DETAILS, {}),
  getTopics: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.TEST, { params })
    }
    return apiGlobal.get(endPoints.TEST, { params })
  },
  initConversation: (lessonId: string) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.INIT_CONVERSATION, {
        lesson_id: lessonId,
      })
    }
    return apiGlobal.post(`${endPoints.INIT_CONVERSATION_OPEN}`, {
      lesson_id: lessonId,
    })
  },
  getListLesson: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.LIST_LESSON, {})
    }
    return apiGlobal.get(endPoints.LIST_LESSON, {})
  },
  getScoreBrand: (id: string) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(`${endPoints.GET_SCORE}/${id}`, {})
    }
    return apiGlobal.get(`${endPoints.GET_SCORE_OPEN}/${id}`, {})
  },
  sendUserAudio: (data: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SEND_USER_AUDIO, data, {}, true)
    }
    return apiGlobal.post(endPoints.SEND_USER_AUDIO_OPEN, data, {}, true)
  },
  getResponseConversation: (params: any, queryUrl: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${endPoints.GET_RESPONSE_CONVERSATION}?lesson_id=${queryUrl.lesson_id}&step=${queryUrl.step}`,
        params,
      )
    }
    return apiGlobal.post(
      `${endPoints.GET_RESPONSE_CONVERSATION_OPEN}?lesson_id=${queryUrl.lesson_id}&step=${queryUrl.step}`,
      params,
    )
  },
  getExam: (params?: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_EXAM, params)
    }
    return apiGlobal.get(endPoints.GET_EXAM_OPEN, params)
  },
  getDataTopics: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_DATA_TOPICS, {})
    }
    return apiGlobal.get(endPoints.GET_DATA_TOPICS_OPEN, {})
  },
  getLessonTopics: (params?: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_MORE_TOPICS, params)
    }
    return apiGlobal.get(endPoints.GET_MORE_TOPICS, params)
  },
  getLessonDetail: (params?: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${endPoints.GET_LESSON_DETAIL}/${params?.topic_id}`,
        {},
      )
    }
    return apiGlobal.get(
      `${endPoints.GET_LESSON_DETAIL}/${params?.topic_id}`,
      {},
    )
  },
  getMorePractice: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_MORE_PRACTICE, params)
    }
    return apiGlobal.get(endPoints.GET_MORE_PRACTICE_OPEN, params)
  },
  getProgressBar: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_PROGRESS_BAR, params)
    }
    return apiGlobal.get(endPoints.GET_PROGRESS_BAR_OPEN, params)
  },
  submitPreOrder: () => {
    return apiGlobal.authPost(endPoints.SUBMIT_PRE_ORDER, {})
  },
  translateToVn: (data: any) =>
    axios.get('https://translate.googleapis.com/translate_a/single', {
      params: {
        ...data,
      },
    }),
  getWordInfo: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.GET_WORD_INFO, params)
    }
    return apiGlobal.post(`${endPoints.GET_WORD_INFO_OPEN}`, params)
  },
  submitExitFlowFeedback: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SUBMIT_EXIT_FLOW_FEEDBACK, params)
    }
    return apiGlobal.post(endPoints.SUBMIT_FEEDBACK_OPEN, params)
  },
  submitPromoteFeedback: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SUBMIT_PROMOTE_FEEDBACK, params)
    }
    return apiGlobal.post(endPoints.SUBMIT_FEEDBACK_OPEN, params)
  },
  submitRealTimeFeedback: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SUBMIT_REAL_TIME_FEEDBACK, params)
    }
    return apiGlobal.post(endPoints.SUBMIT_FEEDBACK_OPEN, params)
  },
  submitFeatureFeedback: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SUBMIT_FEATURE_FEEDBACK, params)
    }
    return apiGlobal.post(endPoints.SUBMIT_FEEDBACK_OPEN, params)
  },
  checkIsShowPreOrder: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.CHECK_IS_SHOW_PRE_ORDER, {})
    }
    return apiGlobal.get(endPoints.CHECK_IS_SHOW_PRE_ORDER, {})
  },
  checkDevice: (userID: string) => {
    return apiGlobal.post(`${endPoints.CHECK_DEVICE}`, {})
  },
  getProfile: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_PROFILE, {})
    }
  },
  getUpgradePackage: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_UPGRADE_PACKAGES, params)
    }
    return apiGlobal.get(endPoints.GET_UPGRADE_PACKAGES, params)
  },
  submitUpgrade: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SUBMIT_UPGRADE, params)
    }
  },
  getOrderData: () => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.GET_ORDER_DATA, {})
    }
  },
  trackingPage: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.TRACKING_PAGE, params)
    }
    return apiGlobal.post(endPoints.TRACKING_PAGE, params)
  },
  getTopicOverview: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_TOPIC_OVERVIEW, {})
    }
    return apiGlobal.get(endPoints.GET_TOPIC_OVERVIEW, {})
  },
  getTopicDetail: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_TOPIC_DETAIL, params)
    }
    return apiGlobal.get(endPoints.GET_TOPIC_DETAIL, params)
  },
  getForecastSet: () => {
    if (getAccessToken()) {
      return apiGlobal.authGet(endPoints.GET_FORECAST_SET, {})
    }
    return apiGlobal.get(endPoints.GET_FORECAST_SET, {})
  },
  getSpeechCheck: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(endPoints.SPEECH_CHECK, params, {}, true)
    }
    return apiGlobal.post(endPoints.SPEECH_CHECK, params, {}, true)
  },
}

export default appRequest
